import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { VERIFY_EMAIL } from 'api';
import styles from './VerifyEmailPage.module.scss';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);
  const [error, setError] = useState(null);

  const [verifyEmail] = useMutation(VERIFY_EMAIL, {
    onCompleted: (data) => {
      setIsVerifying(false);
      if (data?.verifyEmail) {
        // Redirect to sign in page with success message
        navigate('/sign_in?emailVerified=true');
      }
    },
    onError: (err) => {
      setIsVerifying(false);
      const errorMessage =
        err?.graphQLErrors?.[0]?.message ||
        err?.message ||
        'Email verification failed. The link may have expired or is invalid.';
      setError(errorMessage);
    },
  });

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Verification token is missing.');
      setIsVerifying(false);
      return;
    }

    console.log('Verifying email with token:', token);
    verifyEmail({
      variables: {
        token: token,
      },
    }).catch((err) => {
      console.error('Verify email error:', err);
    });
  }, [searchParams, verifyEmail]);

  if (isVerifying) {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <h1>Verifying your email...</h1>
          <p>Please wait while we verify your email address.</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <h1>Verification Failed</h1>
          <p className={styles.errorText}>{error}</p>
          <button type="button" onClick={() => navigate('/sign_in')} className={styles.button}>
            Go to Sign In
          </button>
        </div>
      </div>
    );
  }

  // Success case - redirect happens in onCompleted
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1>Email Verified Successfully!</h1>
        <p>Redirecting to sign in page...</p>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
